import React from "react";
import PainelAssistencial from "./PainelAssistencial";

// A aba Residentes reutiliza a mesma visão do Painel (com busca e cadastro para admin)
const Residentes = () => <PainelAssistencial modo="residentes" />;

export default Residentes;
